/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useState, useLayoutEffect } from 'react';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import HtmlReactParser from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';
import { getAccessToken } from '@sureifylabs/ext-frontend-identity';
import { setScreenViewport } from './redux/actions/meta';
import {
  checkmodalReferenceIdString,
  checksQuotes,
  checksTextWithinQuotes,
} from './constants/regex';
import { getThemeFromConfig } from './cruxComponents/utils';
import { getParams } from './util';
import LocalStorageServices from './util/localStorageServices';
import { refreshAccessToken } from './redux/actions/authHandler';
import SessionStorageServices from './util/sessionStorageServices';

/**
 * @description checks the innerHTML string for script tag.
 * @param str
 * @returns {string}
 */
const validateInnerHtml = (str) => {
  if (!str) return '';
  if (typeof str !== 'string') return str;
  try {
    if (str.match(/<script>/gi)) {
      throw new Error('Cannot insert script tags');
    }
    return str;
  } catch (e) {
    console.error(e);
    return '';
  }
};

/**
 * @description sanitizes HTML and prevents XSS attacks.
 * DOMPurify will strip out everything that contains dangerous HTML and thereby prevent XSS attacks and other nastiness.
 * @param str
 * @returns {string}
 */
/**
 * @description checks if a feature flag is enabled
 * @param {string} featureFlagName - The name of the feature flag (e.g., 'REACT_APP_ENABLE_USPS')
 * @returns {boolean} true if the feature flag is enabled, false otherwise
 */
export const isFeatureEnabled = (featureFlagName) => {
  return process.env[featureFlagName] === 'true';
};

const sanitizeInnerHtml = (str, allowTarget = false) => {
  if (!str) return '';
  const options = allowTarget ? { ADD_ATTR: ['target'] } : {};
  // nosemgrep: javascript.dompurify.harden-dompurify-usage
  if (typeof str === 'string') return DOMPurify.sanitize(str, options);
  return str;
};

/**
 * @description builds the nested array based on reflexive_index.
 * e.g. [q0, q0, [q1, q1, [q2, q2]], q0, q0]
 * @param list flattened list of questions
 * @param index
 * @returns {*}
 */
function rebuildQuestionList(list, index, doneIndex = -1) {
  return list.reduce((acc, q, i) => {
    if (q.reflexive_index === undefined) {
      q.reflexive_index = 0;
    }
    if (i >= doneIndex && !q.used && q.reflexive_index === index) {
      acc.push(q);
      q.used = true;
    }
    if (!q.used && q.reflexive_index > index && doneIndex !== list.length) {
      acc.push(rebuildQuestionList(list, q.reflexive_index, i));
    }
    if (i > doneIndex && q.reflexive_index < index) {
      doneIndex = list.length;
    }
    return acc;
  }, []);
}

function getRandomId() {
  return Math.random().toString(36).substring(7);
}

function getPageId(state) {
  if (!state) {
    return window.location.pathname.toLowerCase().split('/')[1] || '';
  }
  const { sections, activeSubsectionId, sectionIndex } = state.questions;
  return get(sections[activeSubsectionId], `[${sectionIndex}].otherParams.current_status`, '');
}

/**
 * Defines breakpoints based on the screen width
 * desktop - above 1024px
 * tablet - between 768px to 1024px, 900px to 1024px for questions screens
 * mobile - less than 768px, 900px for questions screens
 */
const getScreenViewport = (pageId) => {
  const _pageId = pageId || getPageId();
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const maxLandscapeMobileWidth = 926; // mobile devices have max screen width of 926px when in landscape mode
  const mobileBreakpoint = _pageId === 'questions' ? 900 : 768;
  if (
    screenWidth < mobileBreakpoint ||
    (screenHeight < screenWidth &&
      screenHeight < mobileBreakpoint &&
      screenWidth <= maxLandscapeMobileWidth)
  )
    return 'mobile';
  if (screenWidth >= mobileBreakpoint && screenWidth <= 1024) return 'tablet';
  if (screenWidth > 1024) return 'desktop';
  return '';
};

/**
 * Defines breakpoints based on the screen width
 * desktop - above 1024px
 * tablet - between 768px to 1024px
 * mobile - less than 768px
 */
function resizeHandler(dispatch, getState) {
  const {
    meta: { screenViewport },
  } = getState();
  const pageId = getPageId(getState());
  const resizedViewport = getScreenViewport(pageId);
  if (resizedViewport !== screenViewport) {
    dispatch(setScreenViewport(resizedViewport));
  }
}

const _resizeHandler = debounce(resizeHandler, 500);

function resizeListener({ dispatch, getState }) {
  _resizeHandler(dispatch, getState);
}

function singleButtonPage(id) {
  return (
    id === 'quote' || id === 'welcome' || id === 'quotereview' || id === 'review' || id === 'login'
  );
}

function isReview(id) {
  return id === 'quotereview' || id === 'review';
}

function isCustomRole(role) {
  if (!role || typeof role !== 'string') return false;
  return role.toUpperCase() === 'CSR';
}

// check for dtc quote page
function isQuotePage() {
  const role = getParams('role');
  const pageId = getPageId();
  return !isCustomRole(role) && pageId === 'quote';
}

// function isCsrQuotePage() {
//   const role = getParams('role');
//   const pageId = getPageId();
//   return isCustomRole(role) && pageId === 'quote';
// }

function isExitPage(id) {
  return ['knockout', 'thankyou', 'completed', 'noquote', 'nonclean'].includes(id);
}

const buttonLabelMap = {
  login: 'Login',
  signature: 'Begin E-sign',
  quote: 'Get your quote',
  quotereview: 'Continue to application',
  review: 'Continue to application',
};

function isIe() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE');

  // If Internet Explorer, return version number
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
    return true;
  }
  return false;
}

function sanitize$uriefyQuestion(questionId) {
  try {
    return questionId.split(/_\$ureify_/)[1];
  } catch (e) {
    console.error('Failed to sanitize question id');
    return null;
  }
}

function isMatch(question, id) {
  if (
    question &&
    (question.question_id.indexOf(id) > -1 || id.indexOf(question.question_id) > -1)
  ) {
    return true;
  }
  return false;
}

function lookUp(questionsArr, id) {
  return questionsArr.reduce((acc, q) => {
    if (acc) return acc;
    if (isMatch(q, id)) return q;
    if (q.questions) return lookUp(q.questions, id);
    return null;
  }, null);
}

function questionLookup(questionObj, id) {
  return lookUp([questionObj], id);
}

// Customhook for document resize
const useDocumentWidth = () => {
  const [width, setWidth] = useState();
  useLayoutEffect(() => {
    const updateWidth = () => {
      setWidth(document.documentElement.clientWidth);
    };
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return () => window.removeEventListener('resize', updateWidth);
  }, []);
  return width;
};

// const getUserAbandonedData = (questions) => {
//   if (questions && process.env.REACT_APP_ENABLE_LAST_EDIT_DATA === 'true') {
//     console.log('Inside getUserAbandonedData function');
//     const activeSubsectionId = questions?.activeSubsectionId;
//     let currentSection = get(questions, `sections[${activeSubsectionId}]`, []);
//     let questionList=[];
//     let errorsArray=[];
//     if(isCsrQuotePage()){
//       currentSection=currentSection.find((qu)=> !qu?.enableContinue);
//       questionList = get(currentSection, 'questionList', []);
//       errorsArray = get(currentSection, 'errorsArray', []);
//     }else {
//       currentSection=currentSection.slice(-1);
//       questionList = get(currentSection, '[0].questionList', []);
//       errorsArray = get(currentSection, '[0].errorsArray', []);
//     }
//     const abandonedQuestions = new Map();
//     questionList.forEach((q) => {
//       let questionStatus = 'missing';
//       if (q?.response) {
//         questionStatus = errorsArray.find((qu) => qu?.question_id === q?.question_id)
//           ? 'invalid'
//           : 'valid';
//       }
//       abandonedQuestions.set(q?.question_id, {
//         question_id: q?.question_id,
//         transaction_log: q?.transaction_log,
//         question_type: q?.question_type,
//         question_status: questionStatus,
//         num_times_answered: q?.num_times_answered,
//         last_submitted_at: q?.last_submitted_at,
//         section: activeSubsectionId,
//         stored_by:'session_timeout',
//       });
//     });
//     return {
//       abandonedQuestions,
//     };
//   }
// };

// Utility to flatten out nested questions
export const flattenQuestions = (questions, newList = []) => {
  if (Array.isArray(questions) && questions.length) {
    questions.forEach((question) => {
      if (!question.is_hidden && !Array.isArray(question)) {
        newList.push({
          ...question,
        });
      }
      if (get(question, 'questions', []).length && get(question, 'submission_type', '') !== 'all') {
        flattenQuestions(get(question, 'questions', []), newList);
      }
    });
  }
};

const insertReflexiveQuestions = (item) => {
  const reflexiveQ = [];
  flattenQuestions(item, reflexiveQ);
  return reflexiveQ;
};

// Utility for scrolling to top of the screen.
const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// Utility for scrolling to bottom of the screen.
const scrollBottom = () => {
  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
};

// Function for getting masked responses from questionsList
const getMaskedResponses = (questionsList, answersArray) => {
  const maskedQArray = [];
  const maskedQIds = answersArray
    .filter((q) => q.question_id && q.hasMask)
    .map((a) => a.question_id);
  questionsList.forEach((q) => {
    const hasMask = maskedQIds.includes(q.question_id);
    if (hasMask) {
      const response = get(q, 'original_response', q.response);
      maskedQArray.push({
        question_id: q.question_id,
        answer: response,
      });
    }
  });
  return maskedQArray;
};

const getUTCTimestamp = () => {
  const dateIsoString = new Date(new Date().toUTCString()).toISOString();
  return `${dateIsoString.split('.')[0].replace('T', ' ')} UTC`;
  // return `${moment.utc().format('YYYY-MM-DD HH:mm:ss')} UTC`;
};

const getPopupDetails = (question, popupQuestions) => {
  let modalReferenceId;
  let popupQuestion;
  const options = get(question, 'response_options', []);
  const questionText = get(question, 'question_text', '');
  // store modal_reference_id in variable
  if (question.display_type === 'checkbox') {
    const modalReferenceOption = options.filter((option) => {
      const label = get(option, 'label', '');
      return /modal_reference_id=/i.test(label);
    })[0];
    if (modalReferenceOption) {
      modalReferenceId = modalReferenceOption.label
        .match(checksTextWithinQuotes)[0]
        .replace(checksQuotes, '');
    }
  } else if (questionText.match(checkmodalReferenceIdString)) {
    modalReferenceId = questionText
      .match(checkmodalReferenceIdString)[0]
      .split('=')[1]
      .replace(checksQuotes, '');
  }
  // use modalReferenceId to find the question with same id in the popupQuestions array
  if (popupQuestions && popupQuestions.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    popupQuestion = popupQuestions.filter((ques) => {
      return ques.question_id === modalReferenceId;
    })[0];
  }
  // render the Modal with popupQuestions data
  if (popupQuestion) {
    return {
      show: true,
      question: popupQuestion,
    };
  }
  return { show: false, question: '' };
};

const stripHtml = (html) => {
  const tmp = document.createElement('DIV');
  // nosemgrep: javascript.browser.security.insecure-document-method.insecure-document-method
  tmp.innerHTML = sanitizeInnerHtml(html);
  return tmp.textContent || tmp.innerText || '';
};

const parseHtml = (htmlText, clickHandler, isAsterisk = false) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      clickHandler(e);
    }
  };
  return HtmlReactParser(htmlText, {
    replace: (node) => {
      if (node.name === 'a' && node.attribs && node.attribs.modal_reference_id) {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            onClick={clickHandler}
            className='anchor'
            onKeyDown={(e) => handleKeyDown(e)}
            role='button'
            tabIndex='0'
          >
            {node?.children?.[0]?.data}
          </a>
        );
      }
      if (isAsterisk) return stripHtml(htmlText);
    },
  });
};

const retry = (fn, retriesLeft = 5, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft === 0) {
          console.error('maximum retries exceeded');
          reject(error);
          return;
        }
        setTimeout(() => {
          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

const toDashCase = (text) => {
  if (typeof text === 'string') {
    return text.trim().replace(/\s+/g, '-').toLowerCase();
  }
  return text;
};

/**
 * @description scrolls question into viewport.
 * eg: when question is beneath fixed header,
 *     need to scroll the question into visible viewport when focused
 * @param {HTMLElement} element html element to determine its position
 * @param {object} theme theme object to determine headerPosition
 * @param {string} screenViewport current device
 */
const scrollQuestionIntoView = ({
  element,
  theme,
  screenViewport,
  heightFromTop = screenViewport === 'mobile' ? 200 : 350,
}) => {
  const { headerPosition } = getThemeFromConfig(theme, 'globalHeaderTheme');
  const position = get(headerPosition, theme.screenViewport);
  const headerHeight = screenViewport === 'mobile' ? 150 : 200;
  const { top, bottom } = element.getBoundingClientRect() || {};

  if (position && position === 'fixed') {
    if (element && typeof element.getBoundingClientRect === 'function') {
      if ((top || top === 0) && (top < headerHeight || bottom + 20 > window.innerHeight)) {
        if (top < 0) {
          element.scrollIntoView();
        }
        window.scrollBy({ top: -(heightFromTop - top), behavior: 'smooth' });
      }
      if (screenViewport === 'mobile' && bottom > window.screen.height - 150) {
        window.scrollBy({ top: 200, behavior: 'smooth' });
      }
    }
  } else if (position && position === 'static') {
    const { userAgent } = navigator;
    if (
      screenViewport === 'mobile' &&
      userAgent.match(/chrome|chromium|crios/i) &&
      /android/i.test(userAgent)
    ) {
      window.scrollBy(0, -(heightFromTop - top));
    }
  }
};

const shiftFocusOnRouteChange = ({
  creditCardStatus,
  routeChange,
  isReflexive,
  activeReviewedGroupId,
  reviewAction = null,
}) => {
  setTimeout(() => {
    const headerTelEl = document.querySelector('[name="custom-header-banner"] a.tel');
    // const creditCardMsgEl = document.getElementById('CardPointeSuccessFailureLabel-label-label-label');
    const creditCardMsgEl = document.querySelector(
      '#CardPointeSuccessFailureLabel-label-label-label > span > span',
    );
    const giactFailureMsgEl = document.getElementsByClassName('failed-label-question');
    const giactSuccessMsgEl = document.getElementsByClassName('success-label-question');
    let activeReviewGroupSelector = reviewAction
      ? activeReviewedGroupId
      : `group-header-${activeReviewedGroupId}`;
    let activeReviewGroupElement = document.getElementById(activeReviewGroupSelector);
    if (activeReviewedGroupId && !activeReviewGroupElement) {
      activeReviewGroupSelector = 'active-section-header';
      activeReviewGroupElement = document.getElementById(activeReviewGroupSelector);
    }
    // After clicking update in Review page,should scroll to respective groups
    if (activeReviewGroupElement && typeof activeReviewGroupElement.focus === 'function') {
      activeReviewGroupElement.focus();
      activeReviewGroupElement.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
      return;
    }

    // credit card payment submitted
    if (creditCardStatus && !isReflexive && creditCardMsgEl) {
      if (creditCardMsgEl?.innerText) {
        creditCardMsgEl.focus();
        creditCardMsgEl.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
        return;
      }
      // If cancelled, Shift focus to Conditional coverage: payment method question
      const paymentMethodEl = document.getElementById('581ea3aa-d36b-4add-8273-daa4885c5d4c');
      if (paymentMethodEl && typeof paymentMethodEl.focus === 'function') {
        paymentMethodEl.focus();
        paymentMethodEl.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      }
      return;
    }

    // eft failure/success
    const giactStatusMsgEl = giactSuccessMsgEl[0] || giactFailureMsgEl[0];
    if (giactStatusMsgEl && giactStatusMsgEl?.innerText) {
      giactStatusMsgEl.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
      giactStatusMsgEl.focus();
      return;
    }

    // route changed, focus telephone in header
    if (routeChange && headerTelEl && headerTelEl.focus) {
      headerTelEl.focus();
      return;
    }

    // route changed, foucs active breadcrumb if telephone not exists
    if (routeChange && !headerTelEl) {
      // focus on first active breadcrumb on routeChange if tel number is not present in header
      const breadcrumbEls = [...document.querySelectorAll('[name="card-wrapper"]')];
      const activeBcrumbEls = breadcrumbEls?.find((el) => el?.firstChild?.tabIndex === 0);
      const activeBcrumbEl = activeBcrumbEls?.firstChild;
      if (activeBcrumbEl && activeBcrumbEl.focus) {
        activeBcrumbEl.focus();
      }
    }
  }, 100);
};

// integrated getAccessToken from ext-frontend-library
// Argument to getAccessToken is a boolean ( true -> OAuth , false -> SSO).
const checkAuthTypeAndGetAccessToken = async () => {
  if (process.env.REACT_APP_USE_EXT_AUTH === 'true') {
    const ssoAuthConfig = LocalStorageServices.getSSOConfig();
    const { ENABLE: isSSOEnabled, SSO_USER_TYPE } = ssoAuthConfig || {};
    const isSSO = isSSOEnabled && getParams('role') === SSO_USER_TYPE;
    let accessToken = null;
    try {
      // SSO FLOW --> handles the refresh call and finally returns accessToken / null
      if (isSSO) {
        accessToken = await getAccessToken(false);
        return accessToken;
      }

      // OAUTH --> returns null there's no token or expired token and we handle the refresh call
      accessToken = await getAccessToken(true);
      if (!accessToken) {
        accessToken = await refreshAccessToken();
      }
      return accessToken;
    } catch (e) {
      console.log(e);
      if (isSSO) {
        console.log('SSO token fetch failed! clearing tokens to re-initiate sso auth flow');
        LocalStorageServices.clearSSOToken();
      }
      return null;
    }
  }
  // Acquire auth flow
  return LocalStorageServices.getAccessToken();
};

/**
 * Check for login feature object and return true/false
 * check for pages which should bypass login page
 */
const shouldEnableLogin = (loginConfig) => {
  const { enable = false, disableLoginPages = [] } = loginConfig || {};
  if (!enable) return false;
  const pageId = getPageId();
  if (enable) {
    if (Array.isArray(disableLoginPages)) {
      return !disableLoginPages.includes(pageId);
    }
    return enable;
  }
};

/**
 * Retrieves cookie value, else return null
 * @param {String} name cookie key
 * @returns String
 */
const getCookieData = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Decode cookie and parse it to return stored object
 * @param {String} key a key to be retrieved from cookies
 * @returns object or null
 */
const decodeAndParseCookie = (key) => {
  let cookieValue = getCookieData(key);
  if (!cookieValue) return null;
  try {
    cookieValue = decodeURIComponent(cookieValue);
    cookieValue = JSON.parse(cookieValue);
    return cookieValue;
  } catch (err) {
    console.error(`DEBUG:: Failed to decode cookie - ${err}`);
    return null;
  }
};

/**
 * @returns visitorId and utm keys
 */
const getUtmPardotCookie = () => {
  const { search } = window.location;

  // check if query string contain 'utm' tags
  const utmParamsRegex = /&utm_[a-zA-Z]+=/;
  if (utmParamsRegex.test(search)) {
    SessionStorageServices.setLocalValue('utm_query_string', search.substring(1));
  } else {
    SessionStorageServices.removeLocalValue('utm_query_string');
  }

  // retrieve visitor_id from cookie
  const visitorCookieValue = document?.cookie
    ?.split('; ')
    .find((row) => row.match(/visitor_id(\d+)=/gm));
  const visitorID = visitorCookieValue?.split('=')[1];

  return {
    utmSource: getParams('utm_source'),
    utmCampaign: getParams('utm_campaign'),
    visitorID,
  };
};

export {
  validateInnerHtml,
  sanitizeInnerHtml,
  rebuildQuestionList,
  getRandomId,
  resizeListener,
  isReview,
  isCustomRole,
  isQuotePage,
  singleButtonPage,
  buttonLabelMap,
  isIe,
  sanitize$uriefyQuestion,
  questionLookup,
  insertReflexiveQuestions,
  scrollTop,
  scrollBottom,
  getMaskedResponses,
  getPopupDetails,
  parseHtml,
  getUTCTimestamp,
  isExitPage,
  useDocumentWidth,
  retry,
  toDashCase,
  scrollQuestionIntoView,
  shiftFocusOnRouteChange,
  getPageId,
  getScreenViewport,
  checkAuthTypeAndGetAccessToken,
  shouldEnableLogin,
  getCookieData,
  decodeAndParseCookie,
  getUtmPardotCookie,
  stripHtml,
  // getUserAbandonedData,
};
